const de = {
  "nav.expos": "Messen",
  "nav.map": "Karte",
  "nav.ai": "KI",
  "nav.notes": "Notizen",
  "nav.profile": "Profil",

  "splash.tagline": "Intelligenter navigieren. Besser vernetzen.",
  "splash.tag.ai": "KI-gestützt",
  "splash.tag.realtime": "Echtzeit",
  "splash.tag.nav": "Smarte Navigation",
  "splash.stat.expos": "Messen",
  "splash.stat.booths": "Stände",
  "splash.stat.accuracy": "Genauigkeit",
  "splash.trusted": "Weltweit von über 45.000 Fachleuten genutzt",
  "splash.btn.enter": "App starten",
  "splash.btn.demo": "Demo erkunden",

  "expoSelect.title": "Messen entdecken",
  "expoSelect.subtitle.events": "Veranstaltungen verfügbar",
  "expoSelect.search.placeholder": "Messen, Städte, Kategorien suchen...",
  "expoSelect.filter.all": "Alle",
  "expoSelect.filter.active": "Aktiv",
  "expoSelect.filter.upcoming": "Bevorstehend",
  "expoSelect.filter.past": "Vergangen",
  "expoSelect.featured": "Empfohlen • Jetzt live",
  "expoSelect.allEvents": "Alle Veranstaltungen",
  "expoSelect.live": "LIVE",
  "expoSelect.booths": "Stände",
  "expoSelect.attendees": "Besucher",
  "expoSelect.halls": "Hallen",
  "expoSelect.enter": "Eintreten",
  "expoSelect.noResults": "Keine Messen gefunden",
  "status.active": "Aktiv",
  "status.upcoming": "Bevorstehend",
  "status.past": "Vergangen",

  "map.title": "Messeplan",
  "map.subtitle": "World Tech Summit 2026 • Dubai",
  "map.coverage": "Messeabdeckung",
  "map.legend.visited": "Besucht",
  "map.legend.recommended": "Empfohlen",
  "map.legend.important": "Wichtig",
  "map.legend.nonsponsored": "Nicht gesponsert",
  "map.entrance": "EINGANG",
  "map.stat.visited": "Besucht",
  "map.stat.suggested": "Empfohlen",
  "map.stat.total": "Gesamt",

  "booth.score": "KI-Übereinstimmung",
  "booth.contact": "Kontakt",
  "booth.markVisited": "Als besucht markieren",
  "booth.visited": "Besucht",
  "booth.markImportant": "Wichtig markieren",
  "booth.important": "Wichtig",
  "booth.whyAI": "Warum KI?",
  "booth.aiReasoning": "KI-Analyse",
  "booth.quickNote": "Schnellnotiz",
  "booth.notePlaceholder": "Notiz zu diesem Stand hinzufügen...",
  "booth.saveNote": "Notiz speichern",
  "booth.noteSaved": "✓ Notiz gespeichert!",
  "booth.limitedInfo": "Vollständige Infos für gesponserte Stände verfügbar",
  "booth.limitedAI": "Upgrade für KI-Einblicke zu diesem Stand.",
  "sponsor.platinum": "✦ Platin-Sponsor",
  "sponsor.gold": "★ Gold-Sponsor",
  "sponsor.standard": "Standard",
  "sponsor.none": "Nicht gesponsert",

  "ai.title": "KI-Empfehlungen",
  "ai.subtitle": "Personalisiert für Ihr Profil • Live aktualisiert",
  "ai.active": "ExpoFlow KI ist aktiv",
  "ai.analyzing": "420 Stände werden analysiert • Interessen werden abgeglichen",
  "ai.mustVisit": "Unbedingt besuchen",
  "ai.nearby": "Nahegelegene Chancen",
  "ai.notVisited": "Noch nicht besucht",
  "ai.stat.mustVisit": "Muss besuchen",
  "ai.stat.nearby": "In der Nähe",
  "ai.stat.unexplored": "Unerkundet",
  "ai.score": "Punkte",
  "ai.allDone": "Sie haben alles erkundet!",
  "ai.allDoneDesc": "Alle empfohlenen Stände wurden besucht.",

  "progress.title": "Fortschritt & Abdeckung",
  "progress.subtitle": "World Tech Summit 2026 • Ihr Erkundungsbericht",
  "progress.explored": "Erkundet",
  "progress.coverage": "Messeabdeckung",
  "progress.visitedOf": "besucht von Gesamtständen",
  "progress.stat.visited": "Besucht",
  "progress.stat.important": "Wichtig",
  "progress.stat.remaining": "Verbleibend",
  "progress.byHall": "Nach Halle",
  "progress.missedTitle": "Wichtige nicht besuchte Stände",
  "progress.passedTitle": "Stände, an denen Sie vorbeigegangen sind",
  "progress.noVisited": "Noch keine besuchten Stände. Erkunden Sie los!",
  "progress.analytics": "Analytik",
  "progress.time": "Zeit auf der Messe",
  "progress.distance": "Gelaufene Distanz",
  "progress.connections": "Gemachte Verbindungen",
  "progress.notes": "Notizen gemacht",
  "progress.backToMap": "Zurück zur Karte",

  "notes.title": "Besprechungsnotizen",
  "notes.subtitle": "Unternehmenseinträge verfolgt",
  "notes.add": "Hinzufügen",
  "notes.filter.all": "Alle",
  "notes.status.visited": "Besucht",
  "notes.status.followup": "Nachfassen",
  "notes.status.interested": "Interessiert",
  "notes.status.notRelevant": "Nicht relevant",
  "notes.updateStatus": "Status aktualisieren",
  "notes.editNote": "Notiz bearbeiten",
  "notes.share": "Teilen",
  "notes.noNotes": "Keine Notizen hier",
  "notes.noNotesDesc": "Besuchen Sie Stände und machen Sie Notizen, um Ihre Meetings zu verfolgen",
  "notes.save": "Speichern",
  "notes.cancel": "Abbrechen",

  "profile.title": "Profil & Einstellungen",
  "profile.edit": "Bearbeiten",
  "profile.jobTitle": "VP Technologie • InnovateTech GmbH",
  "profile.proMember": "Pro-Mitglied",
  "profile.theme": "App-Design",
  "profile.theme.dark": "Dark Tech",
  "profile.theme.light": "Premium Hell",
  "profile.industry": "Branchenfokus",
  "profile.industry.selected": "ausgewählt",
  "profile.interests": "Interessen & Ziele",
  "profile.notifications": "Benachrichtigungen",
  "profile.notif.ai": "KI-Empfehlungen",
  "profile.notif.ai.desc": "Personalisierte Standempfehlungen erhalten",
  "profile.notif.booth": "Stand-Updates",
  "profile.notif.booth.desc": "Echtzeit-Benachrichtigungen für gespeicherte Stände",
  "profile.notif.reminders": "Meeting-Erinnerungen",
  "profile.notif.reminders.desc": "Erinnerungen für Meetings und Nachfassaktionen",
  "profile.notif.promotions": "Aktionen",
  "profile.notif.promotions.desc": "Messeangebote und Sponsor-Offerten",
  "profile.export": "Meine Daten exportieren",
  "profile.export.desc": "Notizen und Kontakte herunterladen",
  "profile.privacy": "Datenschutzeinstellungen",
  "profile.privacy.desc": "Datennutzung und Sichtbarkeit",
  "profile.help": "Hilfe & Support",
  "profile.help.desc": "FAQ und Kontakt",
  "profile.about": "Über ExpoFlow AI",
  "profile.about.desc": "Version 2.4.1",
  "profile.signout": "Abmelden",
  "profile.footer": "ExpoFlow AI • v2.4.1 • Für Messeprofis",
  "profile.language": "Sprache",
  "lang.tr": "Türkçe",
  "lang.de": "Deutsch",
  "lang.en": "English",
};

export default de;
